import './ShoutoutsTab.scss';

import React, {
  memo,
  useState,
} from 'react';

import {
  Col,
  Row,
} from 'antd';

import {
  IUserShoutoutsFilters,
  UserProfileTabItemType,
} from '../../../../types/tqConnectTypes/user';
import { UserAccountType } from '../../../../types/userTypes';
import { IUserProfileDetails } from '../../types';
import UserShoutouts from './UserShoutouts';

const initialFilters: IUserShoutoutsFilters = {
  type: UserProfileTabItemType.RECEIVED,
};

interface Props {
  userProfileId: string;
  userProfileDetails: IUserProfileDetails;
  accountType: UserAccountType;
  viewerType: UserAccountType;
  isViewerSelf?: boolean;
  shoutoutReceived: number;
  shoutoutGiven: number;
  refreshTQProfileInfo: () => void;
}

const ShoutoutsTab: React.FC<Props> = ({
  userProfileId,
  userProfileDetails,
  accountType,
  viewerType,
  isViewerSelf,
  shoutoutReceived,
  shoutoutGiven,
  refreshTQProfileInfo,
}) => {
  const [filters, setFilters] = useState<IUserShoutoutsFilters>(initialFilters);

  const onChangeFilters = <Key extends keyof IUserShoutoutsFilters>(
    key: Key,
    value: IUserShoutoutsFilters[Key],
  ) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value,
    }));
  };

  return (
    <div className="container user-profile__tab user-profile__tab--shoutouts">
      <Row gutter={16}>
        <Col
          xs={24}
          sm={24}
          md={accountType === 'creator' ? 24 : 14}
          lg={accountType === 'creator' ? 24 : 14}>
          <UserShoutouts
            userProfileId={userProfileId}
            userProfileDetails={userProfileDetails}
            userName={userProfileDetails.userProfile.name}
            viewerType={viewerType}
            isViewerSelf={isViewerSelf}
            filters={filters}
            onChangeFilters={onChangeFilters}
            shoutoutReceived={shoutoutReceived}
            shoutoutGiven={shoutoutGiven}
            refreshTQProfileInfo={refreshTQProfileInfo}
          />
        </Col>
      </Row>
    </div>
  );
};

export default memo(ShoutoutsTab);
